import React from 'react';
import './CardDetailViewTabBar.scss';
import { Tabs } from 'new/elements/Tabs';
import cx from 'classnames';

function CardDetailViewTabBar(props) {
  const { tabs, onTabClicked, selectedTabIndex, noHeaderPadding } = props;
  const mappedTabs = tabs.map((tab) => ({
    label: tab,
    value: tab,
  }));

  const onTabChange = (e, value) => {
    if (onTabClicked) {
      const index = tabs.indexOf(value);
      onTabClicked({ tabName: value }, index);
    }
  };

  return (
    <div
      className={cx('detail-view-tabs-container', {
        'disable-margin': noHeaderPadding,
      })}
    >
      <Tabs tabs={mappedTabs} onChange={onTabChange} value={mappedTabs[selectedTabIndex].value} />
    </div>
  );
}

export default CardDetailViewTabBar;
